
    var riot = require('riot')
    //src: starling/src/tags/node-perspective-annotation.html
riot.tag2('node-perspective-annotation',
  '<svg class="eyebeam" ref="eyebeam"> <path riot-d="{this.getComputedEyebeamPath}" class="eyebeam eyebeam-path" riot-style="fill: none; stroke: {this.perspective.color};" ref="eyebeamPath"> </svg> <div ref="annotation" class="annotation" riot-style="{this.annotationStyle()}" data-id="{this.perspective.id}"> <svg> <path ref="path" riot-d="{this.getPathNeatLine()}" class="x-beam" riot-style="fill: {this.getMidColor()}; stroke: {this.perspective.color}; stroke-width: 2.5px; stroke-linejoin: round"> </svg> <div ref="annotationContainer" class="annotation-container {this.showAnnotation() ? \'active\' : \'\'}" riot-style="background-color: {this.getLightColor()}; border: 1px solid {this.perspective.color}; transform: translate({this.offsetX}px, {this.offsetY}px)" onmouseover="{interceptEvent}" onclick="{interceptEvent}" oncontextmenu="{handleRightClick}"> <div class="grabbable"></div> <h2 class="annotation_perspective_title" riot-style="color: {this.getDarkColor()}"> {this.perspective.label} <i class="material-icons" riot-style="color: {this.perspective.color}">visibility</i> </h2> <div class="title-wrapper"> <h6 ref="title" class="title focusable" onclick="{handleTitleClick}" ondblclick="{ignoreClick}" oninput="{handleInput}" onkeydown="{checkBlurKey}" onpaste="{handleTitlePaste}" onblur="{editTitle}" oncontextmenu="{stopRightClickMenu}" hide="{this.isTooltip()}" contenteditable="{this.canvas.isViewOnly() ? \'false\' : \'true\'}" spellcheck="{(!window.config.embedded && window.user && window.user.settings.spellcheck !== 0) ? \'true\' : \'false\'}" riot-style="background: {this.getLightColor()}" placeholder="add note"> {this._getAnnotation()} </h6> <h6 ref="highlightLayer" class="title text-highlight-layer"></h6> </div> <i ref="info" class="material-icons info {this.isOnboardable() ? \'active\' : \'\'}" onclick="{this.showPopover}">info</i> </div> </div>',
  '',
  'onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" ondblclick="{this.ignoreClick}" ref="main" style="dispay: 3', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

var _searchUi = require('lib/search-ui');

var _constants = require('lib/constants');

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _util = require('lib/util');

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var linkify = require('linkifyjs/html');
var linkifyHtml = function linkifyHtml(input) {
  if (!input) {
    return '';
  }
  return linkify(input);
};
var self = this;
var defaultOffsetX = 48;
var defaultOffsetY = -4;

this.canvas = opts.canvas;
this.nodeTag = opts.nodetag;
this.perspective = opts.perspective;

this.getLightColor = function () {
  return (0, _util.shade)(_this.perspective.color, 0.75);
};
this.getDarkColor = function () {
  return (0, _util.shade)(_this.perspective.color, -0.5);
};
this.getMidColor = function () {
  return (0, _util.shade)(_this.perspective.color, 0.5);
};
this.nodeId = this.nodeTag.id;
this.offsetX = defaultOffsetX;
this.offsetY = defaultOffsetY;
this.canvas.nodePerspectiveAnnotations[this.nodeTag.id + '-' + this.perspective.id] = this;

this.truncatedViewTitle = function () {
  return truncate(_this.nodeTag.instance.title, 24) || "this card";
};

this.truncatedPointTitle = function () {
  return truncate(_this.perspective.label, 24) || "the point of view";
};

function truncate(str, len) {
  return str.length > len ? str.substring(0, len) + '…' : str;
};

this._getAnnotation = function () {
  var p = _this._getPerspective();
  if (!p) {
    return '';
  }
  return p.getAnnotation(_this.nodeTag.id);
};

this.getEyebeamPath = function () {
  var perspective = store.getPerspective(_this.perspective.id);
  var pointNodeTag = _this.canvas.nodeTags[perspective.pointNodeUUID];
  var eyeballRect = pointNodeTag.getEyeballBoundingBox();
  var yOffset = 6;
  var xOffset = 6;
  var dotRect = _this.parent.refs.dot.getBoundingClientRect();

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  var x = (eyeballRect.left - dotRect.left + (dotRect.right - dotRect.left) / 2) / scale;
  var y = (eyeballRect.top - dotRect.top + (dotRect.bottom - dotRect.top) / 2) / scale - yOffset;
  return 'M ' + xOffset + ' ' + yOffset + ' l ' + x + ' ' + y;
};

this.freshen = function () {
  var perspective = store.getPerspective(_this.perspective.id);
  if (!perspective) {
    return;
  }
  var nodeMember = perspective.members.nodes[_this.nodeId];
  if (nodeMember) {
    var displayProperties = nodeMember.displayProperties || {};

    var x = void 0,
        y = void 0;
    if (displayProperties.annotationPosition) {
      x = displayProperties.annotationPosition.x;
      y = displayProperties.annotationPosition.y;
    } else {
      x = defaultOffsetX;
      y = defaultOffsetY;
      //console.log("couldn't parse node member summary", e);

      displayProperties.annotationPosition = { x: x, y: y };
      perspective.setNodeAnnotationPosition({ nodeId: _this.nodeId, x: x, y: y });
    }
    _this.offsetX = x == undefined ? defaultOffsetX : x;
    _this.offsetY = y == undefined ? defaultOffsetY : y;
  }
};

this.interceptEvent = function (e) {
  e.stopPropagation();
};

this.showAnnotation = function () {
  return _this.isActive() || _this.isHovered() || _this.isSearchResult();
};

this.annotationStyle = function () {
  if (!_this.showAnnotation()) {
    return 'display: none';
  }
  return 'display: block';
};

// show annotation with just css changes
this.refreshAnnotation = function () {
  if (!_this.refs) {
    return;
  }
  _this.updateTitle();
  _this.freshen();
  var _refs = _this.refs,
      annotation = _refs.annotation,
      main = _refs.main,
      annotationContainer = _refs.annotationContainer;

  if (_this.showAnnotation()) {
    if (annotation) annotation.style.display = '';
    if (main) main.style.display = '';
    if (annotationContainer && !annotationContainer.classList.contains('active')) {
      annotationContainer.classList.add('active');
    }
    _this.updatePath();
  } else {
    if (annotation) annotation.style.display = 'none';
    if (main) main.style.display = 'none';
    if (annotationContainer && _this.refs.annotationContainer.classList.contains('active')) {
      _this.refs.annotationContainer.classList.remove('active');
    }
  }
};

this.getAnnotationBoundingBox = function () {
  if (_this.refs && _this.refs.annotationContainer) {
    return _this.refs.annotationContainer.getBoundingClientRect();
  }
  return {};
};

this.updateTitle = function () {
  var title = _this._getAnnotation();
  if (_this.refs.title) {
    if (title) {
      title = (0, _util.convertNewlines)((0, _escapeHtml2.default)(title));
      _this.refs.title.innerHTML = title.trim();
      _this.refs.title.innerHTML = linkifyHtml(_this.refs.title.innerHTML);
    } else {
      _this.refs.title.innerHTML = '';
    }
  }
};

this.computeEyebeamPath = function () {
  _this.eyebeamPath = _this.getEyebeamPath();
  _this.refs.eyebeamPath.setAttribute('d', _this.eyebeamPath);
};

this.getComputedEyebeamPath = function () {
  return _this.eyebeamPath;
};

this.setAnnotationPosition = function (x, y, gravity) {
  _perspectivesUi.pui.setNodeAnnotationPosition(_this.perspective.id, _this.nodeId, x, y, gravity);
};

this.getDot = function () {
  return _this.canvas.nodePerspectiveDotTags[_this.nodeTag.id + '-' + _this.perspective.id];
};

this.getPathBeam = function () {
  return 'M 6 2 l 0 5 L ' + (_this.offsetX + 10) + ' ' + (_this.offsetY + 20) + ' l 0 -20 Z';
};

this.getPathLine = function () {
  return 'M 6 9 L ' + (_this.offsetX + 10) + ' ' + (_this.offsetY + 10);
};

this.getPathNeatLine = function () {
  if (!_this.mounted || !_this.refs || !_this.refs.annotationContainer || !_this.getDot().refs || !_this.getDot().refs.dot || !_this.showAnnotation()) {
    return "M 0 0";
  }
  var annotationRect = _this.refs.annotationContainer.getBoundingClientRect();
  var dotRect = _this.getDot().refs.dot.getBoundingClientRect();
  var dotMidX = (dotRect.left + dotRect.right) / 2;
  var dotMidY = (dotRect.top + dotRect.bottom) / 2;
  if (annotationRect.left < dotMidX && dotMidX < annotationRect.right) {
    // vertical line
    return 'M 6 8 l 0 ' + (_this.offsetY + 10);
  } else if (annotationRect.top + 16 < dotMidY && dotMidY < annotationRect.bottom - 20) {
    // horizontal line
    return 'M 6 8 l ' + (_this.offsetX + 10) + ' 0';
  } else if (annotationRect.right < dotMidX) {
    // diagonal left
    var _canvas$getMatrix2 = _this.canvas.getMatrix(),
        scale = _canvas$getMatrix2.scale;

    var x = (annotationRect.right - dotMidX) / scale;
    return 'M 6 8 l ' + (x - 10) + ' ' + (_this.offsetY + 10);
  }
  // diagonal right
  return 'M 6 8 L ' + (_this.offsetX + 10) + ' ' + (_this.offsetY + 10);
};

this.getPathLine = function () {
  return 'M 6 6 L ' + (_this.offsetX + 10) + ' ' + (_this.offsetY + 10);
};

this.getPathHV = function () {
  return 'M 6 3 l 0 ' + (_this.offsetY + 10) + ' l ' + (_this.offsetX + 10) + ' 0';
};

this.enableDragging = function () {
  // only enable dragging on popped out annotations
  _this.dragger = (0, _interactjs2.default)(self.refs.main).draggable({
    onstart: function onstart(e) {
      if (_this.canvas.annotationStyle != 'popout') {
        return;
      }
      if (_this.canvas.isViewOnly()) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      self.canvas.disablePanZoom();
    },
    onmove: function onmove(e) {
      if (_this.canvas.annotationStyle != 'popout') {
        return;
      }
      if (_this.canvas.isViewOnly()) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      var scale = self.canvas.getMatrix().scale;
      var dx = e.dx / scale;
      var dy = e.dy / scale;
      _this.offsetX = (_this.offsetX || 0) + dx;
      _this.offsetY = (_this.offsetY || 0) + dy;
      //          this.setAnnotationPosition(this.offsetX, this.offsetY);
      _this.update();
    },
    onend: function onend(e) {
      if (_this.canvas.annotationStyle != 'popout') {
        return;
      }
      if (_this.canvas.isViewOnly()) {
        return;
      }
      var title = self.refs.title.innerText.trim();
      if (title) {
        _this.editTitle(e);
      }
      self.canvas.enablePanZoom();
      _this.setAnnotationPosition(_this.offsetX, _this.offsetY);
    }
  });
};

this.handleTitleClick = function (e) {
  var target = e.target;

  self.canvas.hidePopups();
  e.stopPropagation();
  e.preventDefault();

  if (target.classList.contains('linkified')) {
    _this.canvas.externalLinkPopover.summon({
      href: target.href,
      anchorTag: target,
      isNotEditable: true
    });
  }

  _searchUi.searchUI.unsetFocusedResult();
};

this.ignoreClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.updatePath = function () {
  if (_this.canvas.annotationStyle == 'in_card') {
    return;
  }
  _this.refs.path.setAttribute("d", _this.getPathNeatLine());
  _this.refs.path.style.fill = _this.getMidColor();
  _this.refs.path.style.stroke = _this.perspective.color;
};

this.displayAnnotation = function () {
  var _refs2 = _this.refs,
      annotation = _refs2.annotation,
      annotationContainer = _refs2.annotationContainer,
      main = _refs2.main;

  annotation.style.display = '';
  if (!annotationContainer.classList.contains('active')) {
    annotationContainer.classList.add('active');
  }
  main.style.display = '';
  _this.updatePath();
  _this.conditionallyShowExplainPopover();
};

this.conditionallyShowExplainPopover = function () {
  if (_this.isOnboardable()) {
    if (window.user && !window.user.closed_perspectives_annotation_tooltip) {
      if (!_this.canvas.explainPopoverIsOpen) {
        _this.showPopover();
      }
    }
  }
};

this.hideAnnotation = function () {
  var _refs3 = _this.refs,
      annotation = _refs3.annotation,
      annotationContainer = _refs3.annotationContainer;

  if (_this.isActive()) return;

  annotation.style.display = 'none';
  annotationContainer.classList.remove('active');
  _this.hidePopover();
};

this.openAnnotation = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _this.setActive(true);
  _this.refs.title.style.display = null;
  _this.refs.info.style.display = _this.isOnboardable() ? null : 'none';
  _this.refreshAnnotation();
  if (!_this._getAnnotation() || opts.setFocus) {
    _this.refs.title.focus();
    _this.refs.info.classList.add('active');
  }
  _this.refs.main.style.zIndex = 11001;
  _this.conditionallyShowExplainPopover();
};

this.showPopover = function () {
  if (_this.isOnboardable()) {
    _this.canvas.perspectiveAnnotationPopoverTag.summon({
      annotationTag: _this
    });
  }
};

this.hidePopover = function () {
  _this.canvas.perspectiveAnnotationPopoverTag.hide();
};

this.closeAnnotation = function () {
  _this.setActive(false);
  _this.refreshAnnotation();
};

this.isActive = function () {
  return _perspectivesUi.pui.isActiveAnnotation(_this.perspective.id, _this.nodeTag.id);
};

this.isSearchResult = function () {
  return _this._isSearchResult;
};

this.setSearchResult = function (bool) {
  return _this._isSearchResult = bool;
};

this.isHovered = function () {
  return _this._isHovered;
};

this.setHovered = function () {
  _this._isHovered = true;
};

this.unsetHovered = function () {
  _this._isHovered = false;
};

this.isTooltip = function () {
  return _this._isHovered && !_this._getAnnotation();
};

this.isOnboardable = function () {
  return !_this.isTooltip() && !_this._getAnnotation();
};

this.setActive = function (bool) {
  _perspectivesUi.pui.setActiveAnnotation(_this.perspective.id, _this.nodeTag.id, bool);
};
this._getPerspective = function () {
  return store.getPerspective(_this.perspective.id);
};

this.handleInput = function (e) {
  // if search modal is open, update search results as you type
  _searchUi.searchUI.unsetFocusedResult();
  _searchUi.searchUI.refreshResults();

  _this.updatePath();
  _this.cleanupTitle();
};
/*
prevent firefox and safari from adding a <br> tag to the title element after the user deletes its contents
*/
this.cleanupTitle = function () {
  var html = self.refs.title.innerHTML;
  if (html.match(/^<br\/?>$/)) {
    self.refs.title.innerText = '';
  }
};

this.checkBlurKey = function (e) {
  var ENTER = _constants.KEY_CODES.ENTER,
      TAB = _constants.KEY_CODES.TAB,
      ESCAPE = _constants.KEY_CODES.ESCAPE,
      UP_ARROW = _constants.KEY_CODES.UP_ARROW,
      DOWN_ARROW = _constants.KEY_CODES.DOWN_ARROW,
      CTRL_Z = _constants.KEY_CODES.CTRL_Z;

  if ((e.ctrlKey || e.metaKey) && e.which == CTRL_Z) {

    if (self.refs.title.innerText.length === 0) {

      e.preventDefault();
      _this.editTitle(e);
      _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return self.canvas.operation.undo();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
      _this.canvas.hidePopups();
    }
  } else if (e.keyCode == ENTER && !e.shiftKey) {
    e.preventDefault();
    window.getSelection().empty();
    e.target.blur();
    _this.refs.info.classList.remove('active');
  } else if (e.keyCode == ESCAPE) {
    e.preventDefault();
    window.getSelection().empty();
    //this.revertTitle(e);
    _this.closeAnnotation();
    _this.canvas.hidePopups();
  }

  _searchUi.searchUI.refreshResults();
};

this.editTitle = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  if (document.activeElement == e.target) return;

  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  var prevTitle = _this._getPerspective().getAnnotation(_this.nodeTag.id);

  var title = self.refs.title.innerText.trim();

  if (!title) {
    _this.setActive(false);
    _this.closeAnnotation();
  }
  if (title.length === 0) {
    self.refs.title.innerText = prevTitle;
  }
  if (title == prevTitle || title === '' && prevTitle == null) {
    return;
  }

  // fix for riotjs bug that would duplicate the content in the title field on update()
  _this.refs.title.innerText = title;

  _this.refs.title.innerHTML = linkifyHtml(_this.refs.title.innerHTML).trim();
  _perspectivesUi.pui.editNodeTitle(_this.nodeTag, title, _this._getAnnotation(), _this._getPerspective());

  _searchUi.searchUI.refreshResults();
  _this.hidePopover();

  if (!window.user.closed_perspectives_annotation_tooltip) {
    window.user.closed_perspectives_annotation_tooltip = 1;
    $.ajax({
      method: 'POST',
      url: '/api/users/display-flags/update',
      data: { closed_perspectives_annotation_tooltip: 1 }
    });
  }

  _this.refs.info.classList.remove('active');
};

this.handleMouseEnter = function (e) {
  _this.showAbove();
  e.stopPropagation();
};

this.handleMouseLeave = function (e) {
  e.stopPropagation();
  _this.unshowAbove();
};

this.showAbove = function () {
  _this.refs.main.style.zIndex = 12000;
};

this.unshowAbove = function () {
  _this.refs.main.style.zIndex = null;
};

this.shuttleToCard = function () {
  var localRef = _this.refs.annotation;
  if (localRef && localRef.parentNode == _this.refs.main) {
    var remoteRef = _this.nodeTag.getAnnotationsTag().refs.annotationContainer;
    localRef.parentNode.removeChild(localRef);
    remoteRef.appendChild(localRef);
    _this.refs.main.style.display = '';
  }
};

this.shuttleToPopout = function () {
  var localRef = _this.nodeTag.getAnnotationsTag().getShuttledAnnotation(_this.perspective.id);
  if (localRef) {
    var remoteRef = _this.refs.main;
    localRef.parentNode.removeChild(localRef);
    remoteRef.appendChild(localRef);
    _this.refs.main.style.display = '';
    _this.refs.path.setAttribute('d', _this.getPathNeatLine());
  }
};

this.stopRightClickMenu = function (e) {
  e.stopPropagation();
  _this.canvas.hidePopups();
};

this.handleRightClick = function (e) {
  if (!e.altKey) {
    e.preventDefault();
    e.stopPropagation();
    _this.canvas.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      nodePerspectiveAnnotation: _this
    });
  }
};

this.on('updated', function () {
  if (_this.canvas.annotationStyle == 'in_card') {
    _this.shuttleToCard();
  } else {
    _this.refs.main.style.display = '';
  }
});

this.on('mount', function () {
  _this.mounted = true;
  _this.enableDragging();
  $(_this.refs.title).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
  _this.updateTitle();
  _this.freshen();
  if (_this.canvas.annotationStyle == 'in_card') {
    _this.shuttleToCard();
  } else {
    _this.refs.main.style.display = '';
  }
  var tags = _this.canvas.perspectiveAnnotationTags;
  tags[_this.perspective.id] = tags[_this.perspective.id] || {};
  tags[_this.perspective.id][_this.nodeTag.id] = _this;
});

this.freshen();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-perspective-annotation')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-perspective-annotation.html
// module id = 648
// module chunks = 0